import { render } from "./nay-button.vue?vue&type=template&id=28144893&scoped=true"
import script from "./nay-button.vue?vue&type=script&lang=js"
export * from "./nay-button.vue?vue&type=script&lang=js"

import "./nay-button.vue?vue&type=style&index=0&id=28144893&scoped=true&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28144893"]])

export default __exports__